import React from "react";
import { Row, Col } from "antd";
import { InputItem } from "../../../components/forms/FormItems";
import ChildrenAnimationWrapper from "../../../components/animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import AutoCompleteItem from "../../../components/forms/AutoCompleteItem";
import PhoneNumberItem from "../../../components/forms/PhoneNumberItem";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";

const PatientContact = () => {
  return (
    <ChildrenAnimationWrapper>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
          <ResponsiveItemsWrapper>
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={1}>
                <PhoneNumberItem
                  name="contact_info.phone_number"
                  category="patient"
                />
              </AnimationChildWrapper>
            </div>
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={2}>
                <PhoneNumberItem
                  name="contact_info.mobile_number"
                  category="patient"
                />
              </AnimationChildWrapper>
            </div>
          </ResponsiveItemsWrapper>

          <ResponsiveItemsWrapper>
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={3}>
                <AutoCompleteItem
                  name="address.city"
                  category="patient"
                  city={true}
                />
              </AnimationChildWrapper>
            </div>
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={4}>
                <InputItem name="address.street" category="patient" />
              </AnimationChildWrapper>
            </div>
          </ResponsiveItemsWrapper>

          <ResponsiveItemsWrapper>
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={5}>
                <InputItem name="address.house_number" category="patient" />
              </AnimationChildWrapper>
            </div>
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={6}>
                <InputItem name="address.apartment_number" category="patient" />
              </AnimationChildWrapper>
            </div>
          </ResponsiveItemsWrapper>
        </Col>
      </Row>
    </ChildrenAnimationWrapper>
  );
};

export default PatientContact;
